/**
 * Data pools for the "Recent Purchase" social proof toast.
 * Names lean Hispanic/Latina to match the audience of El Cambio Hormonal.
 */

export const FIRST_NAMES = [
  'María',
  'Sofía',
  'Camila',
  'Valentina',
  'Lucía',
  'Isabella',
  'Daniela',
  'Mariana',
  'Andrea',
  'Carolina',
  'Gabriela',
  'Paula',
  'Renata',
  'Antonella',
  'Florencia',
  'Martina',
  'Catalina',
  'Victoria',
  'Elena',
  'Laura',
  'Ana',
  'Natalia',
  'Adriana',
  'Verónica',
  'Patricia',
  'Mónica',
  'Sandra',
  'Claudia',
  'Lorena',
  'Mariela',
  'Cecilia',
  'Pilar',
  'Rocío',
  'Beatriz',
  'Carmen',
  'Inés',
  'Jimena',
  'Ximena',
  'Macarena',
  'Esperanza',
  'Julia',
  'Emilia',
  'Regina',
  'Alejandra',
  'Constanza',
  'Bianca',
  'Romina',
  'Agustina',
  'Belén',
  'Magdalena',
]

export const LAST_INITIALS = [
  'M.',
  'R.',
  'G.',
  'L.',
  'P.',
  'S.',
  'T.',
  'V.',
  'C.',
  'D.',
  'F.',
  'H.',
  'J.',
  'N.',
  'O.',
  'A.',
  'B.',
  'E.',
]

export const US_CITIES = [
  'Miami, FL',
  'Houston, TX',
  'Los Angeles, CA',
  'San Antonio, TX',
  'Dallas, TX',
  'Phoenix, AZ',
  'New York, NY',
  'Chicago, IL',
  'Orlando, FL',
  'Tampa, FL',
  'San Diego, CA',
  'Las Vegas, NV',
  'Atlanta, GA',
  'Denver, CO',
  'Austin, TX',
  'El Paso, TX',
  'Albuquerque, NM',
  'Sacramento, CA',
  'San Francisco, CA',
  'San Jose, CA',
  'Fort Worth, TX',
  'Jersey City, NJ',
  'Tucson, AZ',
  'Charlotte, NC',
  'Raleigh, NC',
  'Nashville, TN',
  'Boston, MA',
  'Philadelphia, PA',
  'Brooklyn, NY',
  'Queens, NY',
  'Minneapolis, MN',
  'Seattle, WA',
  'Portland, OR',
  'Salt Lake City, UT',
  'Kansas City, MO',
  'Indianapolis, IN',
  'Columbus, OH',
  'Hialeah, FL',
  'Fort Lauderdale, FL',
  'McAllen, TX',
]

export const FALLBACK_PRODUCTS = [
  {
    title: 'Pack Despertar',
    editionLabel: 'Physical Book',
    priceNumber: 27,
    priceText: '$27',
    thumbnailUrl: null as string | null,
    weight: 0.7,
  },
  {
    title: 'Edición Digital',
    editionLabel: 'Digital Edition',
    priceNumber: 17,
    priceText: '$17',
    thumbnailUrl: null as string | null,
    weight: 0.3,
  },
]

export type ScannedProduct = {
  title: string
  editionLabel: string | null
  priceNumber: number
  priceText: string
  thumbnailUrl: string | null
  weight?: number
}
